/**
 * Shared email-template category vocabulary.
 *
 * Extracted from CommunicationTemplatesPage so the tenant Settings page and the
 * Platform Console Email Template Library render identical labels and colours
 * (COMMUNICATION_DESIGN.md §5.7 — D3). Single source of truth: adding a category
 * here surfaces it in both portals.
 */

export const CATEGORY_LABELS: Record<string, string> = {
  AUTHENTICATION: 'Authentication',
  INSPECTION: 'Inspection',
  PROCEDURE: 'Procedure',
  AUTHORIZATION: 'Authorization',
  SERVICE: 'Service',
  EQUIPMENT: 'Equipment',
  COMMERCIAL: 'Commercial',
  CUSTOMER: 'Customer',
  SYSTEM: 'System',
};

export const CATEGORY_COLORS: Record<string, string> = {
  AUTHENTICATION: 'bg-blue-500/10 text-blue-700 dark:text-blue-400',
  INSPECTION: 'bg-amber-500/10 text-amber-700 dark:text-amber-400',
  PROCEDURE: 'bg-purple-500/10 text-purple-700 dark:text-purple-400',
  AUTHORIZATION: 'bg-orange-500/10 text-orange-700 dark:text-orange-400',
  SERVICE: 'bg-cyan-500/10 text-cyan-700 dark:text-cyan-400',
  EQUIPMENT: 'bg-green-500/10 text-green-700 dark:text-green-400',
  COMMERCIAL: 'bg-lime-500/10 text-lime-700 dark:text-lime-400',
  CUSTOMER: 'bg-pink-500/10 text-pink-700 dark:text-pink-400',
  SYSTEM: 'bg-muted text-muted-foreground',
};

export function categoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category;
}
